var timer = null;

function ResetMenuTimer(alertText) {
    ManualReset(alertText);
}

function ManualReset(alertText) {
    if (timer != null)
	    timer.Reset();
	RefreshAuthentication(alertText);
}

function InitTimer(sessionWarning, sessionExpired) {
	if (timer == null)
		timer = new Timer(sessionWarning, sessionExpired);

	if (timer != null) {
	    clearInterval(timer.timerId);
	    timer.timerId = setInterval("timer.CountDown()", 1000);
	}
	ManualReset();
}

function Timer(warningTimeOut, overallTimeOut) {
	//properties
	this.timerId = null;
	this.nMins = 0;
	this.nSecs = 0;
	this.isTimedOut = 0;
	this.iOverallTimeOut = overallTimeOut;
	this.iWarningTimeOut = warningTimeOut;
	this.Targets = new Array();
	this.timeleft = 0;
	this.TimeOutWarningDisplayed = false;

	//methods
	this.Reset = TimerReset;
	this.CountDown = TimerCountDown;
	this.TimeOutWarning = TimerTimeOutWarning;
	this.Shutdown = TimerShutdown;
	this.TimeOutWarningMsg = CreateTimeOutWarningMsg;
	this.TimeOutWarningTitle = CreateTimeOutWarningTitle;
	this.NewTimeOutWarning = UpdateTimeOutWarning;

	this.RegisterTarget = function RT(pFn) { this.Targets.push(pFn); }
	this.UnregisterTarget = function UT(pFn) {
		for (var n = 0; n < this.Targets.length; n++) {
			if (this.Targets[n] == pFn) {
				this.Targets.splice(n, 1);
				break;
			}
		}
	}
}

// Resets the timer
function TimerReset() {
	this.nMins = this.iOverallTimeOut - 1;
	this.nSecs = 60;
	TimerOutput(this.iOverallTimeOut, 0);
}

// Counts down the timer
function TimerCountDown() {
	if (this.iOverallTimeOut - this.iWarningTimeOut > this.nMins) {
		this.TimeOutWarning();
	}

	if (this.nSecs == 0) {
		this.nSecs = 59;
		this.nMins--;
		this.NewTimeOutWarning(this.iWarningTimeOut - this.nMin);
	}
	else
		this.nSecs--;

	TimerOutput(this.nMins, this.nSecs);

	if (this.nSecs == 0) //we check auth time remaining once per minute
	{
		if (this.timeLeft <= 0 || this.nMins <= 0) {
			this.isTimedOut = 1;
			this.Shutdown();
		}
        //else {
        //    //Keep session alive as log as timer is running - otherwise the session would timeout
        //    KeepSessionAlive();
        //}
	}

	var dt = new Date();
	for (var n = 0; n < this.Targets.length; n++) {
		if (this.Targets[n] != null)
			try {
				this.Targets[n].call(this, dt);
			} catch (errorMsg) { }
	}
}

// Displays time remaining in the menu bar
function TimerOutput(minutes, seconds) {
	var strSeconds = seconds;
	var strMinutes = minutes;

    var timerNow = (minutes * 60) + seconds;
    var keepSessionAlive = ((timerNow % 300) == 15);//call every 5 min with 15 sec delay
    //Keep session alive as long as timer is running - otherwise the session would timeout
    if (keepSessionAlive)
        KeepSessionAlive();

	if (seconds < 10) strSeconds = "0" + seconds;
	if (minutes < 10) strMinutes = "0" + minutes;

	$("#timeLeft").text(strMinutes + ":" + strSeconds);
}


// Popups the time out warning window
function TimerTimeOutWarning() {

	if (this.iWarningTimeOut == 0)
		return;

	if (!this.TimeOutWarningDisplayed) {
		this.TimeOutWarningDisplayed = true;
		PrepareExistingPopUp(true);
		var title = this.TimeOutWarningTitle();
		var msg = this.TimeOutWarningMsg();
		showConfirmationEx(msg, TimeOutWarningConfirmCallback, TimeOutWarningCancelCallback, title, false);
	}
}

function UpdateTimeOutWarning() {
	if (this.iWarningTimeOut == 0)
		return;

	if (this.TimeOutWarningDisplayed) {
		var title = this.TimeOutWarningTitle();
		var msg = this.TimeOutWarningMsg();
		updatePopupMessageWindow(msg, title);
	}
}

function CreateTimeOutWarningMsg() {
	var minutesLeft = this.nMins + 1;
	if (minutesLeft == 1)
		return $("#TimeOutWarningMsg1").val();
	else {
		var msg = $("#TimeOutWarningMsg").val();
		return msg.replace("{0}", minutesLeft);
	}
}

function CreateTimeOutWarningTitle() {
	var minutesInactive = this.iOverallTimeOut - this.nMins - 1;
	if (minutesInactive == 1)
		return $("#TimeOutWarningTitle1").val();
	else {
		var msg = $("#TimeOutWarningTitle").val();
		return msg.replace("{0}", minutesInactive);
	}
}

function TimeOutWarningConfirmCallback() {
    if (timer != null)
	    timer.TimeOutWarningDisplayed = false;
	PrepareExistingPopUp(false);
	ResetMenuTimer('TimeOutWarningConfirmCallback');
}

function TimeOutWarningCancelCallback() {
    if (timer != null)
	    timer.TimeOutWarningDisplayed = false;
    PrepareExistingPopUp(false);
    if (timer != null) {
	    timer.isTimedOut = 0;
	    timer.Shutdown();
    }
}

// Shutsdown the timer and logout
function TimerShutdown() {
	clearInterval(this.timerId);
	LogOutSystem(this.isTimedOut);
}

function LogOutSystem(isTimedOut) {
	isSystemLoggedOut = true;
	if (isTimedOut == null)
		isTimedOut = 0;

	if(isTimedOut == 1)
		Logout($("#LogoutReasonSessionTimeout").val());
	else
		Logout($("#LogoutReasonUserLogout").val());
}

function RefreshAuthentication(alertText, failedAttempt) {
    if (failedAttempt == null || failedAttempt == undefined || isNaN(failedAttempt))
        failedAttempt = 0;
    var actionUrl = $("#RefreshAuthenticationURL").val();
	var request = $.ajax({
	    url: actionUrl,
	    method: "GET",
	    //success: function (result) {
	        //console.log(">>> RefreshAuthentication: success: result=" + result.success + "; ATTEMPT=" + failedAttempt);
	        //check result returned by controller - don't logout because you might be in log-in process
	        //if (!result.success)
	        //    timer.Shutdown();
	    //},
	    error: function (result) {
	        console.log(">>> RefreshAuthentication: ERROR; ATTEMPT=" + failedAttempt);
	        //showAlert(alertText + $("#AuthenticationRefreshError").val(), 'Error');
	        if (failedAttempt < 3)//retry up to 3 times with 5 seconds delay
	            setTimeout(RefreshAuthentication, 5000, alertText, failedAttempt + 1);
	        else if (timer != null && timer.Shutdown != null && typeof (timer.Shutdown) == "function")
	            timer.Shutdown();
	    }
	});
}




// in case there is an open popupwinodw, temporarily chnage its id and message class to not conflict with the TimeOut confirmation
function PrepareExistingPopUp(disable)
{
	if (disable) {
		$("#popupWindow").attr("id", "popupWindow_tempDis");
		$('#popupWindow_wnd_title').attr("id", "popupWindow_wnd_title_tempDis");
		$('.popupMessage').removeClass("popupMessage").addClass("popupMessage_tempDis");
	}
	else{
		$("#popupWindow_tempDis").attr("id", "popupWindow");
		$('#popupWindow_wnd_title_tempDis').attr("id", "popupWindow_wnd_title");
		$('.popupMessage_tempDis').removeClass("popupMessage_tempDis").addClass("popupMessage");
	}
}

// ------------------------------------
// Used to keep track of Sign timeout
// ------------------------------------
function ResetTimeout(timeoutInterval) {
    if (sessionStorage.reSignTimeOutId != undefined && sessionStorage.reSignTimeOutId != "null")
        window.clearTimeout(sessionStorage.reSignTimeOutId);
    sessionStorage.reSignTimeOutId = window.setTimeout(SignCRFTimeOut, timeoutInterval);
}

function SignCRFTimeOut() {
    sessionStorage.reSignTimeOutId = null;
}

function HasSignCRFTimedOut() {
    return (sessionStorage.reSignTimeOutId == undefined || sessionStorage.reSignTimeOutId == "null") ? 1 : 0;
}

function KeepSessionAlive() {
    var actionUrl = $("#KeepSessionAliveURL").val();
	var request = $.ajax({
	    url: actionUrl,
	    method: "POST"//,
	    //success: function (result) {
	        //console.log(">>> KeepSessionAlive: success;");
	    //},
	    //error: function (result) {
	    //    console.log(">>> KeepSessionAlive: FAILED;");
	    //}
	});
}